import { useMediaQuery } from "@material-ui/core";
import Dialog from "components/Dialog";
import { EmptyList } from "components/PaginationList/Styles";
import { EmptyTableContent } from "components/Table/NothingDisplay";
import useText from "constants/text";
import { InationalTransportPoint, IProductPick, ItemAtPoint } from "contexts/RequestQuoteContext";
import React, { useState } from "react";
import ListCatalogue from "./ListCatalogue";

interface IDialogCatalog {
  open: boolean;
  onClose: () => void;
  onValidate: (products: ItemAtPoint[]) => void;
  productsChecked: ItemAtPoint[];
  products: IProductPick[];
  isForDelivery?: boolean;
  productsToPick?: ItemAtPoint[];
  // eslint-disable-next-line react/no-unused-prop-types
  positionPoint?: number;
  point?: InationalTransportPoint;
  productsDelivered?: ItemAtPoint[];
}

export default function DialogCatalog({
  open,
  onClose,
  onValidate,
  productsChecked,
  products,
  isForDelivery = false,
  productsToPick,
  point,
  productsDelivered,
}: IDialogCatalog) {
  const { text } = useText();
  const [newProductsChecked, setNewProductsChecked] = useState(productsChecked || []);

  const onProductItemChecked = (item: IProductPick) => {
    const selectedIndex = isForDelivery
      ? newProductsChecked?.findIndex((o) => o?.product?._id === item?._id && o?.product?.pickup === item?.pickup)
      : newProductsChecked?.findIndex((o) => o?.product?._id === item?._id);

    const pickedItem = productsToPick.find((p) => p?.product?._id === item?._id);

    let newSelected: Array<ItemAtPoint> = [];
    if (selectedIndex === -1) {
      newSelected = newProductsChecked?.concat({ product: item, counter: 1, remainder: pickedItem.counter - 1 });
    } else if (selectedIndex >= 0) {
      newSelected = newProductsChecked.slice(0, selectedIndex).concat(newProductsChecked.slice(selectedIndex + 1));
    }
    setNewProductsChecked(newSelected);
  };

  const onProductCounterChanged = (item: IProductPick, counter: number) => {
    const arrayOFproduct = newProductsChecked;
    const objIndex = isForDelivery
      ? newProductsChecked?.findIndex(
          (object) => object?.product?._id === item?._id && object?.product?.pickup === item?.pickup
        )
      : newProductsChecked?.findIndex((object) => object?.product?._id === item?._id);
    if (objIndex !== -1) {
      const newValue = counter - arrayOFproduct[objIndex].counter;
      if (!isForDelivery) {
        arrayOFproduct[objIndex].remainder += newValue;
      }
      arrayOFproduct[objIndex].counter = counter;
      setNewProductsChecked([...arrayOFproduct]);
    }
  };

  const handleConfirm = () => {
    onValidate(newProductsChecked);
  };

  const isSmallScreen = useMediaQuery("xs");

  return (
    <Dialog
      title={text.catalog.deliver}
      open={open}
      handleClose={onClose}
      handleConfirm={handleConfirm}
      confirmButtonTitle={text.all.validation}
      maxWidth="lg"
      height={isSmallScreen ? "650px" : "auto"}
    >
      <ListCatalogue
        allProducts={products}
        productsChecked={newProductsChecked}
        onChange={onProductItemChecked}
        onProductCounterChanged={onProductCounterChanged}
        isForDelivery={isForDelivery}
        productsToPick={productsToPick}
        point={point ? JSON.parse(JSON.stringify(point)) : null}
        productsDelivered={productsDelivered}
      />
    </Dialog>
  );
}
